if (!customElements.get('product-variant-swatches')) {
  class ProductVariantSwatches extends HTMLElement {
    constructor() {
      super();
      this.container = this;
      this.productHandle = this.dataset.productHandle;
      this.groupTag = this.dataset.groupTag;
      this.variantChangeUnsubscriber = undefined;
      
      if (!this.productHandle || !this.groupTag) {
        console.warn('[PDP Variant Swatches] Missing product handle or group tag');
        return;
      }
      
      this.fetchAndRenderSwatches();
      this.onVariantChange();
    }
  
  fetchAndRenderSwatches() {
    const searchQuery = `group:${this.groupTag}`;
    const searchUrl = `/search?q=${encodeURIComponent(searchQuery)}&view=swatches-json`;
    
    fetch(searchUrl)
      .then((res) => res.text())
      .then((raw) => {
        if (Shopify.designMode) {
          raw = raw.replace(/<[^>]*>?/gm, "");
        }
        
        let data;
        try {
          data = JSON.parse(raw);
        } catch (err) {
          console.error(`[PDP Variant Swatches] Failed to parse JSON:`, err, raw);
          return;
        }
        
        const related = data.products || [];
        
        if (related.length > 0) {
          this.processSwatches(related);
        }
      })
      .catch((err) => {
        console.error(`[PDP Variant Swatches] Error fetching swatches:`, err);
      });
  }
  
  processSwatches(related) {
    const currentProductData = document.querySelector('[data-product-json]');
    let currentProductMetafields = null;
    
    try {
      if (currentProductData) {
        const currentProduct = JSON.parse(currentProductData.textContent);
        currentProductMetafields = currentProduct.metafields?.custom?.color_swatch_list
      }
    } catch (err) {
      console.error(`[PDP Variant Swatches] Failed to parse current product metafields:`, err);
    }
    
    const swatches = related.filter((item) => {
      const hasUrl = item.url && item.url.length > 0;
      const hasImage = item.featured_image && item.featured_image.length > 0;
      const isNotCurrent = item.handle !== this.productHandle;
      const hasValidColorSwatches = this.hasValidColorSwatches(item, currentProductMetafields);   
      return hasUrl && hasImage && isNotCurrent && hasValidColorSwatches;
    });

    this.container.innerHTML = '';
    if (swatches.length === 0) {
      console.log(`[PDP Variant Swatches] No valid swatches found`);
      return;
    }

    swatches.forEach((product) => {
      this.container.insertAdjacentHTML("beforeend", this.buildSwatch(product));
    });
  }
  
  hasValidColorSwatches(product, currentProductMetafields) {
    if (!currentProductMetafields || !Array.isArray(currentProductMetafields)) {
      console.log(`[PDP Variant Swatches] No current product metafields, allowing product: ${product.title}`);
      return true;
    }
    
    const productMetafields = product.metafields?.custom?.color_swatch_list;
    if (!productMetafields || !Array.isArray(productMetafields)) {
      console.log(`[PDP Variant Swatches] No product metafields for: ${product.title}`);
      return false;
    }
    
    const currentSwatchLabels = currentProductMetafields.map(swatch => swatch.label).filter(Boolean);
    const productSwatchLabels = productMetafields.map(swatch => swatch.label).filter(Boolean);
    const hasMatchingSwatches = productSwatchLabels.some(label => currentSwatchLabels.includes(label));    
    return hasMatchingSwatches;
  }
  
  buildSwatch(product) {
    const title = product.title || '';
    const rawUrl = product.url || '#';

    const u = new URL(rawUrl, window.location.origin);
    u.searchParams.delete('_pos');
    u.searchParams.delete('_sid');
    u.searchParams.delete('_ss');

    const url = u.pathname + u.search;
    let swatchValue = '';
    let swatchFocalPoint = '';
    let swatchType = 'none';
    
    const productOptions = product.options || [];
    const productMetafields = product.metafields?.custom?.color_swatch_list || [];
    
    if (productMetafields && Array.isArray(productMetafields) && productMetafields.length > 0) {
      const firstSwatch = productMetafields[0];
      
      if (firstSwatch.image) {
        const imageUrl = firstSwatch.image.includes('?') 
          ? `${firstSwatch.image}&width=50` 
          : `${firstSwatch.image}?width=50`;
        swatchValue = `url(${imageUrl})`;
        swatchFocalPoint = firstSwatch.image.presentation?.focal_point || '';
        swatchType = 'image';
      } else if (firstSwatch.color && firstSwatch.second_color) {
        swatchValue = `linear-gradient(90deg, ${firstSwatch.color} 0%, ${firstSwatch.color} 50%, ${firstSwatch.second_color} 50%, ${firstSwatch.second_color} 100%)`;
        swatchType = 'gradient';
      } else if (firstSwatch.color) {
        swatchValue = firstSwatch.color;
        swatchType = 'solid';
      }
    }
    
    return `
      <a href="${url}" class="stitching__label swatch-input__label swatch-input__label--square">
        <span class="swatch qw" style="--swatch--background: ${swatchValue};${swatchFocalPoint ? ` --swatch-focal-point: ${swatchFocalPoint};` : ''}"></span>
      </a>
    `;
  }
  
  onVariantChange() {
    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event.data.variant;
      if (variant && variant.id) {
        this.fetchAndRenderSwatches();
      }
    });
  }
  
  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }
}

customElements.define('product-variant-swatches', ProductVariantSwatches);
}